import React from 'react';
import clsx from 'clsx';
import { TypedMemo } from '../../common/types';
import { IntegrationTypeIcon } from '../../music24/components/IntegrationTypeIcon/IntegrationTypeIcon';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the whole panel; each part uses its own slice of it */
import styles from './PresavePanel.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface PresaveServiceRowProps {
  /** A `MusicAPIIntegrationID` value. */
  integrationType: string;
  label: string;
  count: number;
  /** Share of the busiest service, 0-1. The bar is proportional, not absolute. */
  share: number;
}

/** One music service's share of the pre-saves: mark, name, bar, count. */
const PresaveServiceRowComponent: React.FC<PresaveServiceRowProps> = ({ integrationType, label, count, share }) => {
  return (
    <div className={clsx(styles.serviceRow, count === 0 && styles.serviceRowEmpty)}>
      <IntegrationTypeIcon integrationType={integrationType} size={18} />
      <span className={styles.serviceName}>{label}</span>
      <span className={styles.serviceTrack}>
        {count > 0 && <i className={styles.serviceFill} style={{ width: `${Math.max(6, share * 100)}%` }} />}
      </span>
      <span className={styles.serviceValue}>{count}</span>
    </div>
  );
};

export const PresaveServiceRow = TypedMemo(PresaveServiceRowComponent);
